const eModalTypes = {
  EMT_ERROR: 'error',
  // EMT_CONFIRM: 'confirm',
};

export default eModalTypes;
